import WorkingGenuisIcon from './WorkingGenuisIcon';

export default WorkingGenuisIcon;
